module.exports = __webpack_public_path__ + "img/model-join-2.91759834.png";